// eslint-disable-next-line max-len
export { DispensaryOrderingDetailsController as DispensaryOrderingDetails } from './dispensary-ordering-details-controller';
